import { Copy } from 'lucide-react'
import type { ReactNode } from 'react'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { copyText } from '@/lib/clipboard'

interface LinkFieldProps {
  url: string
  /** The field's accessible name. */
  label: string
  onCopied?: () => void
  /** More buttons after Copy, such as Open. */
  children?: ReactNode
}

/** A link in a read-only field with its buttons at the end, as the customer links show them. */
export function LinkField({ url, label, onCopied, children }: LinkFieldProps) {
  async function copy() {
    try {
      await copyText(url)
      toast.success('Link copied')
      onCopied?.()
    } catch {
      toast.error("We couldn't copy the link. Select it and copy it by hand.")
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Input
        readOnly
        value={url}
        aria-label={label}
        className="min-w-64 flex-1 font-mono text-xs"
        onFocus={(event) => event.currentTarget.select()}
      />
      <Button type="button" variant="outline" onClick={() => void copy()}>
        <Copy /> Copy
      </Button>
      {children}
    </div>
  )
}
